/* 
 *  Copyright © Ludvik Michalek, Bigfoot Interactive
 *  http://www.bigfoot.cz/
 *  
 *  Requires js-cookie
 */

function GlobalPopup(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	var SHOW_DELAY = 1500;
	var EXPIRATION_DAYS = 7;

	
	/* PRIVATE VARIABLES */
	var overlay;
	var popupContent;
	var closeButton;
	var cookieId;
	var visible = false;


	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	
	
	
	function checkCookie(){
		var status = parseInt(Cookies.get(cookieId));
		if(status !== 1) {
			setTimeout(show, SHOW_DELAY);
		} else {
			_this.container.remove();
		}
	}
	
	
	function saveCookie(){
		Cookies.set(cookieId, 1, { expires: EXPIRATION_DAYS });
	}
	
	
	function show(){
		overlay.addClass('visible');
		_this.container.addClass('visible');
		bodyScrollLock.disableBodyScroll(popupContent[0]);
		visible = true;
	}
	
	
	function hide(){
		saveCookie();
		overlay.removeClass('visible');
		_this.container.removeClass('visible');
		bodyScrollLock.enableBodyScroll(popupContent[0]);
		visible = false;
	}
	

	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			// object references
			overlay = $('#global-popup-overlay');
			popupContent = $('.popup-content', _this.container);
			closeButton = $('button.close', _this.container);
			
			// init
			cookieId = 'global-popup-' + _this.container.data('id');
			checkCookie();
	
			// handlers
			closeButton.click(function(e){
				e.preventDefault();
				hide();
			});		
			$(document).keyup(function (e) {
				if (visible && e.key === "Escape") {
					hide();
				}
			});
			
			_this.inited = true;
		}
	};


	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
